<form [formGroup]="registroActividadSitioProcesamientoFormGroup">
  <br>
  <h4 class="secondary-header"> Datos del sitio de procesamiento</h4>
  <div class="row">
    <mat-form-field class="col-12">
      <input matInput placeholder="Nombre sitio de procesamiento:" formControlName="nombre" required>
      <mat-error *ngIf="registroActividadSitioProcesamientoFormGroup.get('nombre')?.hasError('required')">
        Debe ingresar nombre del sitio de procesamiento
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <span class="arial">¿Se procesa semilla para terceros y/o con fines comerciales?</span>
    <div class="row mb-1">
      <mat-radio-group aria-label="" required (change)="onChangeServiciosTerceros($event)">
        <mat-radio-button [checked]="brindaServiciosTercero == true" [value]="true">Si</mat-radio-button>
        <mat-radio-button [checked]="brindaServiciosTercero == false" [value]="false">No (solo se procesa semilla para
          uso propio)</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="section-row">
    <rpe-registro-actividad-sitio-procesamiento-equipamiento-form [formInput]="equipamientoFormInput"
      (formStatusChanges)="equipamientoStatusChange($event)" (formValueChanges)="equipamientoChange($event)">
    </rpe-registro-actividad-sitio-procesamiento-equipamiento-form>
  </div>
  <ng-container *ngIf="isLoaded">
    <br>
    <div>
      <h4 class="secondary-header"> Domicilio</h4>
    </div>
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaFormInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)" [withCountryOption]="false">
    </rpe-direcciones-geograficas-form>
  </ng-container>
  <div>
    <h4 class="secondary-header"> Contacto del sitio de procesamiento</h4>
  </div>
  <rpe-datos-contacto-form [formInput]="datosContactoFormInput" (formStatusChanges)="datosContactoStatusChange($event)"
    (formValueChanges)="datosContactoChange($event)"></rpe-datos-contacto-form>
  <hr>
</form>